import { inject, signal } from '@angular/core';
import { AppStateService, HttpErrorService, StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { StationGroup } from '../../../models';

/** when extending this class be sure to implement ngOnInit */
export abstract class NgxAimViewStationGroupsClass {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  httpErrorService = inject(HttpErrorService);
  appStateService = inject(AppStateService);

  groups: StationGroup[] = [];
  locations = this.appStateService.getLocations();
  selectedLocation = this.appStateService.getDefaultLocation();
  isLoading = signal(true);
  routes = PublicRoutes;

  init() {
    this.findAllStationGroups();
  }

  findAllStationGroups() {
    this.isLoading.set(true);
    this.stationsService.findAllStationGroups(this.selectedLocation.Id).subscribe({
      next: (groups) => this.onGroupSuccess(groups),
      error: (err) => this.onGroupError(err),
    });
  }

  onGroupSuccess(groups: StationGroup[]) {
    this.isLoading.set(false);
    this.groups = groups;
  }

  onGroupError(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load station groups');
  }

  onLocationChange() {
    this.findAllStationGroups();
  }

  onGroupClick(group: StationGroup) {
    // We might need to reset the station service here. What happens when a user clicks on a different group?
    this.stationsService.setSelectedGroup(group);
  }
}
